var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"admin-admin-module"
	],
	"./approval/approval.module": [
		"./src/app/approval/approval.module.ts",
		"approval-approval-module"
	],
	"./customers/customers.module": [
		"./src/app/customers/customers.module.ts",
		"customers-customers-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts"
	],
	"./map/map.module": [
		"./src/app/map/map.module.ts",
		"map-map-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"common",
		"reports-reports-module"
	],
	"./svmore/svmore.module": [
		"./src/app/svmore/svmore.module.ts",
		"common",
		"svmore-svmore-module"
	],
	"./user-management/user-management.module": [
		"./src/app/user-management/user-management.module.ts",
		"user-management-user-management-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;